import { isEmpty } from 'lodash';

export default (filters) =>
  Object.entries(filters).reduce((acc, [key, value]) => (isEmpty(value) ? acc : { ...acc, [key]: value }), {});
